import bags from "../assets/nikolay-bags.webp";
import tutus from "../assets/nikolay-tutus.webp";
import leotard from "../assets/Nikolay-leotard.webp";
import warmUp from "../assets/nikolay-warm-up.webp";
import pointerShoes from "../assets/nikolay-pointer-shoes.webp";
import belletShoes from "../assets/nikolay-ballet-shoes.webp";
import mystique from "../assets/nikolay-mystique.webp";
import tools from "../assets/nikolay-tools.webp";

export const faturedData = [
  {
    id: 1,
    name: "Leotards",
    image: leotard,
    route: "/collections/youth-leotards",
  },
  {
    id: 2,
    name: "Dance Bags",
    image: bags,
    route: "/collections/bags",
  },
  {
    id: 3,
    name: "Mystique",
    image: mystique,
    route: "/collections/mystique",
  },
  {
    id: 4,
    name: "Tutus",
    image: tutus,
    route: "/collections/tutus",
  },
  {
    id: 5,
    name: "Ballet Shoes",
    image: belletShoes,
    route: "/collections/soft-ballet-shoes",
  },
  {
    id: 6,
    name: "Pointe Shoes",
    image: pointerShoes,
    route: "/collections/pointe-shoes",
  },
  {
    id: 7,
    name: "Training Tools",
    image: tools,
    route: "/collections/training-tools",
  },
  {
    id: 8,
    name: "Warm Ups",
    image: warmUp,
    route: "/collections/warm-ups",
  },
];
